var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTrifecta(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.969,
    height: 16.969
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "icon-trifecta_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#737c81",
    d: "M0 0h16.969v16.969H0z",
    "data-name": "Rectangle 1411"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon - Trifecta"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    clipPath: "url(#icon-trifecta_svg__a)",
    "data-name": "Group 3329"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#ffb100",
    d: "M.75 2.3A1.547 1.547 0 102.3.75 1.547 1.547 0 00.75 2.3",
    "data-name": "Path 5720"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#aeb7bc",
    d: "M.75 8.484A1.547 1.547 0 102.3 6.937 1.547 1.547 0 00.75 8.484",
    "data-name": "Path 5721"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#de6627",
    d: "M.75 14.672a1.547 1.547 0 101.55-1.547 1.547 1.547 0 00-1.55 1.547",
    "data-name": "Path 5722"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M6.906 2.297h9.313",
    "data-name": "Line 1246"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M6.906 8.484h9.313",
    "data-name": "Line 1247"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#737c81",
    d: "M6.906 14.672h9.313",
    "data-name": "Line 1248"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNi45NjkiIGhlaWdodD0iMTYuOTY5Ij48ZGVmcz48Y2xpcFBhdGggaWQ9ImEiPjxwYXRoIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzczN2M4MSIgZD0iTTAgMGgxNi45Njl2MTYuOTY5SDB6IiBkYXRhLW5hbWU9IlJlY3RhbmdsZSAxNDExIi8+PC9jbGlwUGF0aD48L2RlZnM+PGcgZGF0YS1uYW1lPSJJY29uIC0gVHJpZmVjdGEiPjxnIGZpbGw9Im5vbmUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgc3Ryb2tlLXdpZHRoPSIxLjUiIGNsaXAtcGF0aD0idXJsKCNhKSIgZGF0YS1uYW1lPSJHcm91cCAzMzI5Ij48cGF0aCBzdHJva2U9IiNmZmIxMDAiIGQ9Ik0uNzUgMi4zQTEuNTQ3IDEuNTQ3IDAgMSAwIDIuMy43NSAxLjU0NyAxLjU0NyAwIDAgMCAuNzUgMi4zIiBkYXRhLW5hbWU9IlBhdGggNTcyMCIvPjxwYXRoIHN0cm9rZT0iI2FlYjdiYyIgZD0iTS43NSA4LjQ4NEExLjU0NyAxLjU0NyAwIDEgMCAyLjMgNi45MzcgMS41NDcgMS41NDcgMCAwIDAgLjc1IDguNDg0IiBkYXRhLW5hbWU9IlBhdGggNTcyMSIvPjxwYXRoIHN0cm9rZT0iI2RlNjYyNyIgZD0iTS43NSAxNC42NzJhMS41NDcgMS41NDcgMCAxIDAgMS41NS0xLjU0NyAxLjU0NyAxLjU0NyAwIDAgMC0xLjU1IDEuNTQ3IiBkYXRhLW5hbWU9IlBhdGggNTcyMiIvPjxwYXRoIHN0cm9rZT0iIzczN2M4MSIgZD0iTTYuOTA2IDIuMjk3aDkuMzEzIiBkYXRhLW5hbWU9IkxpbmUgMTI0NiIvPjxwYXRoIHN0cm9rZT0iIzczN2M4MSIgZD0iTTYuOTA2IDguNDg0aDkuMzEzIiBkYXRhLW5hbWU9IkxpbmUgMTI0NyIvPjxwYXRoIHN0cm9rZT0iIzczN2M4MSIgZD0iTTYuOTA2IDE0LjY3Mmg5LjMxMyIgZGF0YS1uYW1lPSJMaW5lIDEyNDgiLz48L2c+PC9nPjwvc3ZnPgo=";
export { SvgIconTrifecta as ReactComponent };